import { render, staticRenderFns } from "./logPerDevice.vue?vue&type=template&id=516bad14"
import script from "./logPerDevice.vue?vue&type=script&lang=js"
export * from "./logPerDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports